import { render, staticRenderFns } from "./my.vue?vue&type=template&id=4452a225&scoped=true&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"
import style0 from "./my.vue?vue&type=style&index=0&id=4452a225&scoped=true&lang=css&"
import style1 from "./my.vue?vue&type=style&index=1&id=4452a225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452a225",
  null
  
)

export default component.exports